module.exports = __webpack_public_path__ + "static/img/zhuanli.2d524fef.png";